(function () {

    angular
        .module('smartertoolsApp')
        .factory('leaseProviderService', ['$http', 'refreshToken', 'cacheControl', '$rootScope', leaseProviderService]);

    function leaseProviderService($http, refreshToken, cacheControl, $rootScope) {
        const urlBase = apiRootUrl;
        let getActiveLeasesPromise;
        let getProductsAvailablePromise;
        let getPricingTablePromise;
        let getActivityReportPromise;

        return {
            clearLeaseCache: clearLeaseCache,
            getActiveLeases: getActiveLeases,
            getProductsAvailable: getProductsAvailable,
            startLease: startLease,
            modifyLease: modifyLease,
            getLeaseHistory: getLeaseHistory,
            stopLease: stopLease,
            getPricingTable: getPricingTable,
            getActivityReport: getActivityReport
        };

        // -----------------------------------------------

        function clearLeaseCache() {
            cacheControl.getCache('myAccountCache').remove(`${urlBase}v1/account/leases/active`);
        }

        function getActiveLeases() {
            if (getActiveLeasesPromise)
                return getActiveLeasesPromise;
            getActiveLeasesPromise = refreshToken.refreshToken()
                .then(() => $http.get(`${urlBase}v1/account/leases/active`, { cache: cacheControl.getCache('myAccountCache') }))
                .then((response) => {
                    getActiveLeasesPromise = null;
                    return response.data.Leases;
                });
            return getActiveLeasesPromise;
        }

        function getProductsAvailable() {
            if (getProductsAvailablePromise)
                return getProductsAvailablePromise;
            getProductsAvailablePromise = refreshToken.refreshToken()
                .then(() => $http.get(`${urlBase}v1/account/leases/product-table`, { cache: cacheControl.getCache('myAccountCache') }))
                .then((response) => {
                    getProductsAvailablePromise = null;
                    return response.data.ProductLines;
                });
            return getProductsAvailablePromise;
        }

        function startLease(email, customerName, referenceData, sendEmail, productId, addonIds) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${urlBase}v1/account/leases/start`,
                    JSON.stringify({
                        EmailAddress: email,
                        CustomerName: customerName,
                        ReferenceData: referenceData,
                        SendEmail: sendEmail,
                        ProductId: productId,
                        AddonIds: addonIds
                    })))
                .then((response) => {
                    cacheControl.clearAllCaches();
                    $rootScope.$broadcast('cache-clear', {});
                    return response.data;
                });
        }

        function modifyLease(leaseId, productId, addonIds, sendEmailToCustomer) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${urlBase}v1/account/leases/modify`,
                    JSON.stringify({
                        LeaseId: leaseId,
                        ProductId: productId,
                        AddonIds: addonIds,
                        SendEmailToEndUser: sendEmailToCustomer
                    })))
                .then((response) => {
                    cacheControl.clearAllCaches();
                    $rootScope.$broadcast('cache-clear', {});
                    return response.data;
                });
        }

        function getLeaseHistory(leaseId) {
            return refreshToken.refreshToken()
                .then(() => $http.get(`${urlBase}v1/account/leases/${leaseId}/history`))
                .then((response) => response.data.History);
        }

        function stopLease(leaseId) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${urlBase}v1/account/leases/${leaseId}/stop`))
                .then((response) => {
                    cacheControl.clearAllCaches();
                    $rootScope.$broadcast('cache-clear', {});
                    return response.data;
                });
        }

        function getPricingTable() {
            if (getPricingTablePromise)
                return getPricingTablePromise;
            getPricingTablePromise = refreshToken.refreshToken()
                .then(() => $http.get(`${urlBase}v1/account/leases/pricing`, { cache: cacheControl.getCache('myAccountCache') }))
                .then((response) => {
                    getPricingTablePromise = null;
                    return response.data.Categories;
                });
            return getPricingTablePromise;
        }

        function getActivityReport() {
            if (getActivityReportPromise)
                return getActivityReportPromise;
            getActivityReportPromise = refreshToken.refreshToken()
                .then(() => $http.get(`${urlBase}v1/account/leases/activity-report`))
                .then((response) => {
                    getActivityReportPromise = null;
                    return response.data;
                });
            return getActivityReportPromise;
        }
    }

})();